import { render, staticRenderFns } from "./BannerMessages.vue?vue&type=template&id=c1789836&"
import script from "./BannerMessages.vue?vue&type=script&lang=js&"
export * from "./BannerMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports